import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { PaypalObjectDataset } from 'app/model/dataset/paypal.dataset';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(PaypalObjectDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class PaypalObjectDatasetAdapter extends TabularTypeDatasetAdapter<PaypalObjectDataset, Model.DatasetResource> {
    protected async _toResource(dataset: PaypalObjectDataset): Promise<Model.DatasetResource> {
        return await this._toResourceInternal(dataset, Metamodel.modelFor(PaypalObjectDataset).name);
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: PaypalObjectDataset): Promise<PaypalObjectDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, PaypalObjectDataset.MODEL);
    }
}
